import { HTTP_AP_ListMortgageOfferParserBatches_Request_Filter } from '@api-new/documentservice';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { MortgageBatchTableRowModel } from '../models/mortgage-batch-table-row.model';

export const mortgageDocAiTableFilterDefaults: Partial<HTTP_AP_ListMortgageOfferParserBatches_Request_Filter> = {
  name: '',
  mortgageOfferParserBatchId: null,
  mortgageOfferParserBatchType: null,
};

export const mortgageDocAiTableRowDefinition: TableRowDefinitionModel<MortgageBatchTableRowModel, null>[] = [
  {
    columnLabel: 'Batch Status',
    columnKey: 'statusIcon',
    type: RowDefinitionTypeEnum.LabeledImg,
    width: {
      min: '60px',
      max: '60px',
    },
  },
  {
    columnLabel: 'Id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Number,
    width: {
      min: '25px',
      max: '25px',
    },
  },
  {
    columnLabel: 'Name',
    columnKey: 'name',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '150px',
      max: '500px',
    },
  },
  {
    columnLabel: 'Type',
    columnKey: 'type',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '50px',
      max: '80px',
    },
  },

  {
    columnLabel: 'Created at',
    columnKey: 'createdAt',
    type: RowDefinitionTypeEnum.DateWithTime,
    width: {
      min: '50px',
      max: '80px',
    },
  },

  {
    columnLabel: '# of Documents',
    columnKey: 'entryCount',
    type: RowDefinitionTypeEnum.Number,
    width: {
      min: '60px',
      max: '50px',
    },
  },
];
